
import { Link } from 'react-router-dom';

export default function Footer() {
  const handleNewsletterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const email = (form.elements.namedItem('email') as HTMLInputElement).value;
    
    if (email) {
      alert('Thank you for subscribing!');
      form.reset();
    }
  };

  return (
    <footer className="bg-[#0D0D0D] mt-20">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4">
              LOAD&SMOKE
            </h3>
            <p className="text-lg text-gray-400 font-light mb-6">
              Two brands. One vision.
            </p>
            <p className="text-sm text-gray-500 leading-relaxed">
              Empowering your performance and culinary excellence through dedicated expertise.
            </p>
          </div>

          {/* Blueprint Performance Links */}
          <div>
            <h4 className="text-white text-base font-medium mb-6 uppercase tracking-wide">
              Performance
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/blueprint-performance"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#14B8A6] transition-all">
                    About Training
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/blueprint-performance"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#14B8A6] transition-all">
                    1-on-1 Coaching
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/blueprint-performance"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#14B8A6] transition-all">
                    Programs
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/blueprint-performance"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#14B8A6] transition-all">
                    Success Stories
                  </span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Meat Mechanic Links */}
          <div>
            <h4 className="text-white text-base font-medium mb-6 uppercase tracking-wide">
              Culinary
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/meat-mechanic"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#06B6D4] transition-all">
                    Recipe Blog
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/meat-mechanic"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#06B6D4] transition-all">
                    Meal Prep Guides
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/meat-mechanic"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#06B6D4] transition-all">
                    Subscribe
                  </span>
                </Link>
              </li>
            </ul>
          </div>

          {/* About Column */}
          <div>
            <h4 className="text-white text-base font-medium mb-6 uppercase tracking-wide">
              About
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/blueprint-performance"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#14B8A6] transition-all">
                    About Coach
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/meat-mechanic"
                  className="text-sm text-gray-400 hover:text-white transition-colors group"
                >
                  <span className="border-b border-transparent group-hover:border-[#06B6D4] transition-all">
                    About Chef
                  </span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter Signup */}
          <div>
            <p className="text-white text-base mb-2">Stay updated with</p>
            <p className="text-white text-base mb-6">both brands</p>
            <form onSubmit={handleNewsletterSubmit} className="relative">
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                required
                className="w-full h-12 bg-transparent border border-gray-700 rounded-l-lg px-4 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-gray-500 transition-colors"
              />
              <button
                type="submit"
                className="absolute right-0 top-0 h-12 w-12 bg-white rounded-r-lg flex items-center justify-center hover:bg-gray-200 transition-colors"
                aria-label="Subscribe"
              >
                <i className="ri-arrow-right-line text-black text-xl"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Legal Bar */}
        <div className="mt-16 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-xs text-gray-500">
              © 2025 Load&Smoke. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-gray-500 hover:text-gray-400 transition-colors"
              >
                Website Builder
              </a>
              <span className="text-xs text-gray-700">|</span>
              <a href="#" className="text-xs text-gray-500 hover:text-gray-400 transition-colors">
                Privacy Policy
              </a>
              <span className="text-xs text-gray-700">|</span>
              <a href="#" className="text-xs text-gray-500 hover:text-gray-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
